// extracted by mini-css-extract-plugin
export default {"aulist":"index_aulist_kRcWE","auitem":"index_auitem_WBCuo","auitemImg":"index_auitemImg_vqkbE","auitemP":"index_auitemP_TZZnt","authornoR":"index_authornoR_yPugk index_auitem_WBCuo"};